import { faRobot } from "@fortawesome/free-solid-svg-icons";
import {
  LayoutDashboard,
  Phone,
  FileText,
  User,
  BarChart3,
  Users,
  HistoryIcon,
  Building2,
  PhoneCall,
  Bot,
  ListChecks,
  PhoneForwarded,
  Layers3,
  UserRoundCheck,
  Timer,
} from "lucide-react";

const SidebarData = [
  {
    id: "19",
    Title: "Call Tracker",
    Link: "/call-tracker-dashboard",
    Icon: BarChart3,
    permission: ["ivr:sidebar_tracker_dashboard"]
  },

  {
    id: "1",
    Title: "Dashboard",
    Link: "/dashboard",
    Icon: LayoutDashboard,
    permission: ["ivr:sidebar_dashboard"]
  },
  {
    id: "1-2",
    Title: "Demographics",
    Link: "/demographics",
    Icon: BarChart3,
    permission: ["ivr:sidebar_demographics_view"]
  },
  {
    id: "1-3",
    Title: "Latency Insights",
    Link: "/latency-insights",
    Icon: Timer,
    permission: ["ivr:sidebar_latency_insights"]
  },
  
  {
    id: "2",
    Title: "Campaigns",
    Link: "/campaigns",
    Icon: Users,
    permission: ["ivr:sidebar_campaigns"]
  },
  {
    id: "3",
    Title: "Leads",
    Link: "/leads",
    Icon: Users,
    permission: ["ivr:sidebar_leads"]
  },
  {
    id: "5",
    Title: "User Management",
    Link: "#",
    Icon: User,
    permission: ["ivr:sidebar_user_management"],
    subMenu: [
      {
        id: "5-1",
        Title: "User List",
        Link: "/user-list",
        Icon: Users,
        permission: ["ivr:sidebar_user_management"]
      },
      {
        id: "5-2",
        Title: "Agent List",
        Link: "/agent-list",
        Icon: Users,
        permission: ["ivr:sidebar_user_management"]
      },
      {
        id: "5-3",
        Title: "Log History",
        Link: "/log-history",
        Icon: HistoryIcon,
        permission: ["ivr:log_history"]
      }
    ]
  },
  {
    id: "8",
    Title: "Company Management",
    Link: "/company-list",
    Icon: Building2,
    permission: ["ivr:sidebar_company_management"],
  },
  {
    id: "9",
    Title: "Script/Resource",
    Link: "/script-resource",
    Icon: FileText,
    permission: ["ivr:sidebar_script_resource"],
  },
  
  {
    id: "11",
    Title: "Call Numbers",
    Link: "/call-numbers",
    Icon: Phone,
    permission: ["ivr:sidebar_numbers_list"],
  },
  {
    id: "11",
    Title: "Dispositions",
    Link: "/disposition-list",
    Icon: ListChecks,
    permission: ["ivr:sidebar_disposition_list"],
  },

  {
    id: "12",
    Title: "Test Call",
    Link: "/initialize-call",
    Icon: PhoneCall,
    permission: ["ivr:sidebar_initialize_call"],
  },
{
  id: "13",
  Title: "Calls",
  Link: "/calls",
  Icon: PhoneCall,
  permission: ["ivr:sidebar_calls"],
  },
  {
    id: "14",
    Title: "Transfer Calls",
    Link: "/live-transfer-calls",
    Icon: PhoneForwarded,
    permission: ["ivr:sidebar_transfer_call"],
  },
  {
  id: "15",
  Title: "Client Assist",
  Link: "/client-assist",
  Icon:  Bot,
  permission: ["ivr:sidebar_ai_assistant"],
},
{
  id: "16",
  Title: "Agent Assist",
  Link: "/agent-assist",
  Icon:  Bot,
  permission: ["ivr:sidebar_ai_assistant"],
},
{
  id: "18",
  Title: "Add Services",
  Link: "/agent-assist-services",
  Icon:  Layers3,
  permission: ["ivr:sidebar_agent_assist_service"],
},
{
  id: "21",
  Title: "Voice Character",
  Link: "/voice-characters",
  Icon:  UserRoundCheck,
  permission: ["ivr:sidebar_agent_assist_service"],
},
{
  id: "17",
  Title: "Reports",
  Link: "/reports",
  Icon: FileText,
  permission: ["ivr:sidebar_reports"],
},

];
export default SidebarData;
